import { getCorrectSuffix as plural } from '@alfa-bank/site-form-helpers/text/get-correct-suffix';

import { DECLINATION_OF_MONTHS, ERROR_PASSED_DATE_GREATEST_CURRENT } from '../../constants';

import { getUTCDateTime } from './get-utc-date-time';
import { getMillisecondsWithUTC } from './get-milliseconds-with-utc';

interface IOptions {
    /** Переводит время в Московское из UTC+0, НЕ ПЕРЕДАВАТЬ ВРЕМЯ С ЧАСОВЫМ ПОЯСОМ */
    convertToMoscowDate?: boolean;
    errorPassedDateGreatestCurrent?: string;
}

// TODO не правильная штука так как использует UTC вместо локального времени для расчета "вчера/сегодня"
// У меня может быть все еще в UTC вчера, но по МСК уже сегодня
/** Переводить дату в ISO формате в строку с форматированием в зависимости от текущей даты*/
export const translateISODateToString = (
    dateStringISO: string,
    {
        errorPassedDateGreatestCurrent = ERROR_PASSED_DATE_GREATEST_CURRENT,
        convertToMoscowDate = false,
    }: IOptions
) => {
    const passedDate = getUTCDateTime(dateStringISO, { convertToMoscowDate });
    const passedDateMilliseconds = getMillisecondsWithUTC(passedDate);

    const currentDate = getUTCDateTime(new Date().toISOString(), { convertToMoscowDate });
    const currentDateMilliseconds = getMillisecondsWithUTC(currentDate);

    // Если дата публикации больше текущей даты, значит ошибка и не стоит вообще ничего выводить
    if (passedDateMilliseconds > currentDateMilliseconds) {
        console.error(errorPassedDateGreatestCurrent);

        return '';
    }

    // Если дата публикации и время на клиенте совпало в точности до миллисекунд
    if (passedDateMilliseconds === currentDateMilliseconds) {
        return '1 минуту назад';
    }

    // Если года разные, выводим в формате 13 сентября 2020
    if (passedDate.utcYear !== currentDate.utcYear) {
        return `${passedDate.utcDate} ${DECLINATION_OF_MONTHS[passedDate.utcMonth]} ${
            passedDate.utcYear
        }`;
    }

    const todayStartDateMilliseconds = Date.UTC(
        currentDate.utcYear,
        currentDate.utcMonth,
        currentDate.utcDate
    );

    const yesterdayStartDateMilliseconds = todayStartDateMilliseconds - 1000 * 60 * 60 * 24;

    // Если дата публикации позавчера или ранее, но в этом году
    if (passedDateMilliseconds < yesterdayStartDateMilliseconds) {
        return `${passedDate.utcDate} ${DECLINATION_OF_MONTHS[passedDate.utcMonth]} в ${
            passedDate.utcHourFull
        }:${passedDate.utcMinutesFull}`;
    }

    // Если дата публикации была вчера
    if (
        passedDateMilliseconds > yesterdayStartDateMilliseconds &&
        passedDateMilliseconds < todayStartDateMilliseconds
    ) {
        return `Вчера в ${passedDate.utcHourFull}:${passedDate.utcMinutesFull}`;
    }

    // Если дата публикации выпадает на сегодня
    const diffMilliseconds = currentDateMilliseconds - passedDateMilliseconds;
    const diffHours = Math.floor(diffMilliseconds / (1000 * 60 * 60));
    // Если будет 30 секунд, то при делении мы получим 0.5, и далее при округлении 0
    // На секунды уже не бьем, поэтому при нуле тоже ставим "1 минуту назад"
    const diffMinutes = Math.floor(diffMilliseconds / (1000 * 60)) || 1;

    if (passedDateMilliseconds > todayStartDateMilliseconds) {
        if (diffHours >= 1) {
            return `${diffHours} ${plural(diffHours, {
                form1: 'час',
                form2: 'часа',
                form3: 'часов',
            })} назад`;
        }

        return `${diffMinutes} ${plural(diffMinutes, {
            form1: 'минуту',
            form2: 'минуты',
            form3: 'минут',
        })} назад`;
    }
};
